export default "__VITE_ASSET__AXE3Npz6__"